import {connect} from 'react-redux';
import ModalPreviewDocument from './ModalPreviewDocument';
import {createFinalPDF} from '../../../modules/Inspection/actions/steps/createFinalPDF';
import {getFile} from '../../actions/files/getFile';

const mapStateToProps = ({
                           auth: {accessToken}
                         }) => ({
  accessToken
});

export default connect(
  mapStateToProps,
  {createFinalPDF, getFile}
)(ModalPreviewDocument);
